import React from 'react';
import styled from 'styled-components';

import { Text } from 'components/typography';

const NumbersContainer = styled.div`
  ${({ theme }) => theme.breakpoints.maxTablet} {
    margin: 3.2rem 0;
    display: grid;
    grid-auto-flow: column;
  }

  ${({ theme }) => theme.breakpoints.minDesktop} {
    position: absolute;
    top: 0;
    right: 26%;
    height: calc(100% - 28px);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const NumberWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.maxMobile} {
    width: 100%;
  }

  ${({ theme }) => theme.breakpoints.minTablet} {
    width: 10.9rem;
  }
`;

const Number = styled.span`
  display: block;
  font-size: 4.8rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.8rem;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    font-size: 3.2rem;
  }
`;

const NumberText = styled(Text)`
  white-space: pre-line;
  font-size: 1.4rem;
`;

const Numbers = ({ numbers }) => (
  <NumbersContainer>
    {numbers.map((item) => (
      <NumberWrapper key={item.text}>
        <Number>{item.number}</Number>
        <NumberText>{item.text}</NumberText>
      </NumberWrapper>
    ))}
  </NumbersContainer>
);

export default Numbers;
